<template>
    <div class="userinfoPage">
        <div class="bgBox"><img src="./../../../../assets/home/bg-top.png" alt=""></div>
        <div class="top"></div>
        <div class="header">
            <i @click="goback"> <img src="./../../../../assets/home/back.jpg" alt=""> </i>
            <span>个人资料</span>
        </div>
        <div class="userBox">
            <div class="userlogo"><img src="@/assets/home/userlogo.png" alt="" ref="userlogo"></div>
            <span class="username" ref="username">{{userInfo.nickname}}</span>
        </div>
        <div class="list">
            <ul>
                <li>
                    <span class="itemTitle">我的ID</span>
                    <span class="itemText">{{this.userInfo.id}}</span>
                </li>
                <li>
                    <span class="itemTitle">手机</span>
                    <router-link class="itemBtn itemText" to="/home/usercenter/userinfo/telephone" 
                    tag="span" v-if="telBind">去绑定</router-link>
                    <span class="alipayText" v-else>已绑定</span>
                </li>
                <li>
                    <span class="itemTitle">微信</span>
                    <span class="itemBtn itemText" @click="wechat" v-if="wechatBind">去绑定</span>
                    <span class="alipayText" v-else>已绑定</span>
                </li>
                <li>
                    <span class="itemTitle">支付宝</span>
                    <router-link class="itemBtn itemText" to="/home/usercenter/userinfo/alipay" 
                    tag="span" v-if="alipayBind">去绑定</router-link>
                    <span class="alipayText" v-else>已绑定</span>
                </li>
                <li>
                    <span class="itemTitle">设备验证</span>
                    <span class="itemBtn itemText" @click="device" v-if="deviceBind">去完成</span>
                    <span class="alipayText" v-else>已绑定</span>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return {
            userInfo : [],
            alipayBind:true,
            telBind:true,
            wechatBind:true,
            deviceBind:true,
        }
    },
    methods:{
        goback(){
            if(localStorage.getItem("mark") === "home"){
                this.$router.push({path:"/home"})
                localStorage.removeItem("mark")
            }else if(localStorage.getItem("mark") === "usercenter"){
                this.$router.push({path:"/home/usercenter"})
                localStorage.removeItem("mark")
            }
        },
        reloadindex(){
            this.$router.push({path:"/home/usercenter/userinfo"})
        },
        device(){
            let _this = this
            function setupWebViewJavascriptBridge(callback) {                                            
            if (window.WebViewJavascriptBridge) { 
                return callback(WebViewJavascriptBridge); 
            }       
            if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
            window.WVJBCallbacks = [callback];                                                        
            var WVJBIframe = document.createElement('iframe');                                        
            WVJBIframe.style.display = 'none';                                                        
            WVJBIframe.src = 'https://__bridge_loaded__';                                             
            document.documentElement.appendChild(WVJBIframe);                                                
            setTimeout(function() { 
                document.documentElement.removeChild(WVJBIframe) 
                }, 0)                  
            }                                                                                                      
            setupWebViewJavascriptBridge(function(bridge) {
                alert("即将跳转safari浏览器，请允许下载配置文件")
                bridge.callHandler('checkWhenEnterForeground', {     
                    isOpen: 1,
                    },function(response) {
                })
                bridge.callHandler('startServerCheckDeviceInfo', {     
                    dfUrl: "http://ihbapi.1314wallet.com/user/mk_mobileconfig_xml/?uid=" + localStorage.getItem("UID"),
                    },function(response) {
                })
            })
        },
        wechat(){
            let _this = this
            function setupWebViewJavascriptBridge(callback) {                                            
            if (window.WebViewJavascriptBridge) { 
                return callback(WebViewJavascriptBridge); 
            }       
            if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
            window.WVJBCallbacks = [callback];                                                        
            var WVJBIframe = document.createElement('iframe');                                        
            WVJBIframe.style.display = 'none';                                                        
            WVJBIframe.src = 'https://__bridge_loaded__';                                             
            document.documentElement.appendChild(WVJBIframe);                                                
            setTimeout(function() { 
                document.documentElement.removeChild(WVJBIframe) 
                }, 0)                  
            }                                                                                                      
            setupWebViewJavascriptBridge(function(bridge) {
                bridge.callHandler('loginByWechat', function(response) {
                    console.log("111")                       
                })
                bridge.registerHandler('gotWeChatUserInfo', function(data, responseCallback){
                    console.log("222")  
                    console.log(data)
                    localStorage.setItem("WXuserlogo", data.info.headimgurl)
                    localStorage.setItem("WXnickname", data.info.nickname)
                    localStorage.setItem("WXunionid", data.info.unionid)
                    localStorage.setItem("WXopenid", data.info.openid)
                    
                        if(confirm("是否绑定信息")){
                        bridge.callHandler('encrypt', {
                        uid : localStorage.getItem("UID"),
                        token : localStorage.getItem("UserToken"),
                        WXuserlogo : localStorage.getItem("WXuserlogo"),
                        WXnickname : localStorage.getItem("WXnickname"),
                        WXunionid : localStorage.getItem("WXunionid"),
                        WXopenid : localStorage.getItem("WXopenid"),
                        request_time : Date.parse(new Date())
                    }, function(response) {        //加密获取到的数据 
                        let userInfoCode = response.dataReq
                        let userInfoSign = response.dataSign
                    axios.post("/api/user/bindweixin", {   //user/bindweixin   
                        code : userInfoCode,
                        dataSign : userInfoSign,
                    }).then(res=>{       //发送给后端加密数据 code和md5值，同时获取后端api的加密数据
                        if(res.data.msg == '页面超时，请返回首页'){
                            alert(res.data.msg);
                            _this.$router.push({path:"/home"})
                            return;
                        }
                        console.log(res)
                        console.log(111)
                        if(res.data.status === 1){
                            _this.$router.go(0)
                            window.location.reload()
                        console.log(555)
                        }else{
                            alert(res.data.msg)
                        }
                    }).catch(error=>{
                        alert( "数据请求错误：" + error)
                    })
                })
                        }
                    var responseData = { }
                    //处理完，回调传值给oc
                    responseCallback(responseData)
                })
            })
        },
    },
    created(){
        const _this = this;
        function setupWebViewJavascriptBridge(callback) {                                            
            if (window.WebViewJavascriptBridge) { 
                return callback(WebViewJavascriptBridge); 
            }       
            if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
            window.WVJBCallbacks = [callback];                                                        
            var WVJBIframe = document.createElement('iframe');                                        
            WVJBIframe.style.display = 'none';                                                        
            WVJBIframe.src = 'https://__bridge_loaded__';                                             
            document.documentElement.appendChild(WVJBIframe);                                                
            setTimeout(function() { 
                document.documentElement.removeChild(WVJBIframe) 
            }, 0)                  
        }                                                                                    
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler('checkWhenEnterForeground', {     
                isOpen: 0,
                },function(response) {
            })
        })                 
        setupWebViewJavascriptBridge(function(bridge) { 
            bridge.callHandler('encrypt', {
                idfa : localStorage.getItem("IDFA"),
                open_udid : localStorage.getItem("UDID"),
                ip : localStorage.getItem("IP"),
                device : localStorage.getItem("DEVICE"),
                os : localStorage.getItem("OS"),
                token : localStorage.getItem("UserToken"),
                appversion : localStorage.getItem("APPVERSION"),
                request_time : Date.parse(new Date())
            }, function(response) {        //加密获取到的数据 
                let userInfoCode = response.dataReq
                let userInfoSign = response.dataSign
                axios.post("/api/index/user_info", {      
                    code : userInfoCode,
                    dataSign : userInfoSign,
                }).then(res=>{       //发送给后端加密数据 code和md5值，同时获取后端api的加密数据
                // console.log(res)
                        bridge.callHandler('decrpt', {
                        dataReq : res.data.dataReq,
                        dataSign : res.data.dataSign,
                        }, function(response) {  
                        // ios解密   赋值   渲染
                        _this.userInfo = response.info.data;
                            localStorage.setItem("UserToken", response.info.data.token)
                        //判断支付宝是否完成绑定
                        if(_this.userInfo.alipayname&&_this.userInfo.identity_card_number){
                            _this.alipayBind = false
                            localStorage.setItem("UserAlipay", response.info.data.alipay)
                            localStorage.setItem("UserAlipayName", response.info.data.alipayname)
                        }else{
                            localStorage.setItem("UserAlipay", response.info.data.alipay)
                            localStorage.setItem("UserAlipayName", response.info.data.alipayname)
                            _this.alipayBind = true
                        }
                        //判断手机号是否完成绑定
                        if(_this.userInfo.mobile){
                            _this.telBind = false
                            localStorage.setItem("UserTELNumber", response.info.data.mobile)
                        }else{
                            _this.telBind = true
                        }
                        //判断微信是否完成绑定
                        if(_this.userInfo.weixin_openid){
                            _this.wechatBind = false
                            localStorage.setItem("UserNickname", response.info.data.nickname)
                        }else{
                            _this.wechatBind = true
                        }
                        //判断设备是否完成绑定
                        if(_this.userInfo.udid === ""){
                            _this.deviceBind = true
                        }else{
                            _this.deviceBind = false
                        }
                    })
                }).catch(error=>{
                    if(/Network/ig.test(error)){
                        alert("未连接网络")
                    }else{
                        alert(error)
                    }
                })
            })
        })
    },
    mounted(){
        let name = this.$route.query.alipayName
        let number = this.$route.query.alipayNumber
        if(name,number){
            this.$refs.bindAlipayFalse.$el.style.display = "none"
            this.$refs.bindAlipayTrue.style.display = "block"
            this.$refs.bindAlipayTrue.innerHTML = number + "<br>" + name
        }
        if(localStorage.getItem("UserHeadface")){
            this.$refs.userlogo.src = localStorage.getItem("UserHeadface")
        }
    }
}
</script>

<style lang="scss" scoped>
    .bgBox{
        width:100%;
        height:232px;
        position: absolute;
        z-index: -1;
        top:0;
    }

    // header
    .top{
        height:.2rem;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .userBox{
        width:100%;
        display:flex;
        align-items: center;
        flex-direction: column;
        .userlogo{
            width:.90rem;
            height:.90rem;
            margin-top:.10rem;
        }
        .username{
            font-size: .24rem;
            color:#fff;
            margin-top:.15rem;
            height:.35rem;
        }
    }
 
    .list{
        width:90%;
        margin:.40rem auto 0;
        li{
            width:100%;
            height:.55rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 .10rem;
            font-size: .14rem;
            .itemTitle{
                color:#555555;
            }
            .itemText,.alipayText{
                color:#acacac;
            }
            .itemBtn{
                width:1.10rem;
                height:.38rem;
                line-height: .38rem;
                text-align: center;
                font-size: .16rem;
                color:#222527 ;
                background-image: linear-gradient(112deg, #FFDF42 0%, #FFEC77 100%);
                border-radius: .18rem;
            }
            // 绑定后的class样式
            .alipayText{
                text-align: right;
            }
        }
    }

</style>

